import { Vector3 } from '../types/Vector3'
import { Quaternion } from '../types/Quaternion'

// ==================== CORE FIELD ENUMS ====================

export enum FieldTopology {
  OneD = '1d',
  TwoD = '2d'
}

export enum FieldLayoutType {
  // 1D Layouts
  Line = 'line',
  Circle = 'circle', 
  Spiral = 'spiral',
  
  // 2D Layouts
  Grid = 'grid',
  Hex = 'hex',
  HexSpherical = 'hex-spherical',
  GridSpherical = 'grid-spherical'
}

export enum UpVectorMode {
  WorldUp = 'world-up',     // Constant Y-axis (marching band)
  PathUp = 'path-up'        // Follows curve direction (roller coaster)
}

export enum AlignmentMode {
  Aligned = 'aligned',           // Along field direction (forward march)
  Perpendicular = 'perpendicular' // Facing inward/outward (stadium crowd)
}

export enum HoverDirection {
  Transversal = 'transversal',   // Perpendicular to field (breathing)
  Longitudinal = 'longitudinal'  // Along field direction (snake waves)
}

export enum RotationMode {
  Oscillating = 'oscillating',   // Back-and-forth sway (current behavior)
  Infinite = 'infinite'          // Continuous spinning (new default)
}

// ==================== FIELD INTERFACES ====================

export interface FieldTransform {
  position: Vector3
  rotation: Quaternion
}

export interface FieldAnimationState {
  hoverOffset: Vector3
  rotateOffset: Quaternion
  scaleOffset: number
}

export interface FieldPhaseData {
  hoverPhase: number
  rotatePhase: number
  index: number
  totalCount: number
}

export interface GridCoordinates {
  row: number
  col: number
}

export interface HexCoordinates {
  ring: number
  positionInRing: number
}

// ==================== LAYOUT INTERFACE ====================

export interface LayoutInterface {
  computePosition(index: number, totalCount: number, params: any): Vector3
  computeOrientation(index: number, totalCount: number, params: any): Quaternion
  computeTangent?(index: number, totalCount: number, params: any): Vector3
  computeNormal?(index: number, totalCount: number, params: any): Vector3
  
  // Get main directional vector of the layout
  getDirectionalVector(params: any): Vector3
}

// ==================== BOUNDING BOX ====================

export interface BoundingBox {
  min: Vector3
  max: Vector3
  size: Vector3
}

// ==================== FIELD EVENTS ====================

export interface FieldParameterChange {
  parameterName: string
  oldValue: any
  newValue: any
  timestamp: number
}

export type FieldEventCallback = (change: FieldParameterChange) => void

// ==================== FIELD TYPE PRESETS ====================

export enum FieldTypes {
  BREATHING_SPIRAL = 'breathing-spiral',
  RIPPLE_GRID = 'ripple-grid', 
  SNAKE_LINE = 'snake-line',
  ORGANIC_CIRCLE = 'organic-circle'
} 